import { TimeMagic } from '../utils/TimeMagic';

export const timeManager = new TimeMagic();
